<div *ngIf="!isLoggedIn">
  <mat-toolbar color="primary" class="app-header">
    <div>
      <a class="navbar-brand"  [routerLink]="['']">
        <img src="/assets/images/gefrecon/POCTEP-GEFRECON-without-background.png" width="300" height="50" class="d-inline-block align-top" alt="">
      </a>
    </div>
    <span class="nav-tool-items">
      <mat-form-field class="language">
        <mat-label>Idioma</mat-label>
        <mat-select [(ngModel)]="languageSelected" (ngModelChange)="useLanguage()">
          <mat-option *ngFor="let lang of languages" [value]="lang.value">
            {{lang.viewValue}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <a mat-button [routerLink]="['/login']">{{'NAV_BAR.LOG_IN' | translate}}</a>
    </span>
  </mat-toolbar>
</div>

<div *ngIf="isLoggedIn">
  <mat-toolbar color="primary" class="app-header">
    <div>
      <a class="navbar-brand"  [routerLink]="['']">
        <img src="/assets/images/gefrecon/POCTEP-GEFRECON-without-background.png" width="200" height="50"  alt="">
      </a>
    </div>
    <div class="nav-tool-items">
      <div *ngIf="showUserBoard">
        <mat-form-field class="language">
          <mat-label>Idioma</mat-label>
          <mat-select [(ngModel)]="languageSelected" (ngModelChange)="useLanguage()">
            <mat-option *ngFor="let lang of languages" [value]="lang.value">
              {{lang.viewValue}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <span class="name mr-2">{{'NAV_BAR.HELLO' | translate}} {{username}} {{'NAV_BAR.VIEW_NORMAL' | translate}}</span>
        <a mat-button [routerLink]="['/user-panel/password']">{{'NAV_BAR.CHANGE_PASSWORD' | translate}}</a>
        <a mat-button [routerLink]="['/user-panel/tools/list-tools']">{{'NAV_BAR.BOOK_TOOL' | translate}} </a>
        <a mat-button [routerLink]="['/user-panel/bookings']">{{'NAV_BAR.MY_BOOKINGS' | translate}}</a>
        <a mat-button [routerLink]="['/user-panel/cart']">{{'NAV_BAR.MY_CART' | translate}}<mat-icon class="ml-1 cart">add_shopping_cart</mat-icon>{{numberElements}}</a>
        <a mat-button (click)="logout()">{{'NAV_BAR.LOG_OUT' | translate}}</a>
      </div>
      <div *ngIf="showManagerBoard">
        <mat-form-field class="language">
          <mat-label>Idioma</mat-label>
          <mat-select [(ngModel)]="languageSelected" (ngModelChange)="useLanguage()">
            <mat-option *ngFor="let lang of languages" [value]="lang.value">
              {{lang.viewValue}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <span class="name mr-2">{{'NAV_BAR.HELLO' | translate}} {{username}}, {{'NAV_BAR.VIEW_MANAGER' | translate}} </span>
        <a mat-button [routerLink]="['/manager-panel/bookings']">{{'NAV_BAR.MANAGE_BOOKINGS' | translate}}</a>
        <a mat-button [routerLink]="['/manager-panel/register/list-users']">{{'NAV_BAR.MANAGE_USERS' | translate}}</a>
        <a mat-button [routerLink]="['/manager-panel/register/list-tools']">{{'NAV_BAR.MANAGE_TOOLS' | translate}}</a>
        <a mat-button [routerLink]="['/manager-panel/viabilities']">{{'NAV_BAR.VIABILITY' | translate}}</a>
        <a mat-button (click)="logout()">{{'NAV_BAR.LOG_OUT' | translate}}</a>
      </div>
      <div *ngIf="showAdminBoard">
        <mat-form-field class="language">
          <mat-label>{{ 'COMMON.LANGUAGE' | translate }}</mat-label>
          <mat-select [(ngModel)]="languageSelected" (ngModelChange)="useLanguage()">
            <mat-option *ngFor="let lang of languages" [value]="lang.value">
              {{lang.viewValue}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <span class="name mr-2">{{'NAV_BAR.HELLO' | translate}} {{username}}, {{'NAV_BAR.VIEW_ADMIN' | translate}}</span>
        <a mat-button [routerLink]="['/admin-panel/register/list-manager']">{{'NAV_BAR.ADMINISTRATION' | translate}}</a>
        <a mat-button routerLink="login" (click)="logout()">{{'NAV_BAR.LOG_OUT' | translate}}</a>
      </div>
    </div>
  </mat-toolbar>
</div>
